import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function SidebarTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug flex overflow-hidden" data-testid="resume-live-preview">
      <div className="w-[34%] p-5 text-white" style={{ backgroundColor: accent }}>
        <h1 className="text-lg font-bold">{draft.full_name || "Your Name"}</h1>
        <div className="text-white/80 text-[11px] mt-2 space-y-0.5">
          {[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).map((line) => <p key={line}>{line}</p>)}
        </div>
        {draft.skills.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[11px] font-bold uppercase tracking-wider text-white/90">Skills</h2>
            <ul className="mt-1.5 space-y-1">{draft.skills.map((sk) => <li key={sk} className="text-white/85 text-[11px]">{sk}</li>)}</ul>
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[11px] font-bold uppercase tracking-wider text-white/90">Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-white/85 text-[11px] mt-1.5">{ed.degree} {ed.field}<br />{ed.school}</p>)}
          </div>
        )}
      </div>
      <div className="w-[66%] p-6">
        {draft.target_role && <p className="text-slate-500 text-xs font-semibold uppercase tracking-wide">{draft.target_role}</p>}
        {draft.summary && <p className="text-slate-700 mt-2">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
